/**
 * A form field name wrapped in double curly brackets - `{{email}}` - the same
 * notation the form emails and the GHL integration use.
 */
export const placeholderPattern = /\{\{(\w+)\}\}/g;
